import CryptoJS from 'crypto-js';

const SIGNING_SECRET = "6egNhqNB3XeQKeAx+yesjGfCsBWrqL31j0WajxdzgjA=";

export function generateRequestSignature(endpoint) {
    const timestamp = Date.now().toString();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const normalizedEndpoint = `/api${endpoint}`;
    const payload = `${timestamp}:${nonce}:${normalizedEndpoint}`;
    const signature = CryptoJS.HmacSHA256(payload, SIGNING_SECRET).toString();

    return { timestamp, nonce, signature };
}